var map = {
	"./Andrea McLeod-Karim.jpg": 1069,
	"./Anjan Sahu.jpg": 1070,
	"./Manohara Raj Karuppasamy.png": 1071,
	"./Michael O’Sullivan UCC.jpg": 1072,
	"./Mrs Nair.png": 1073,
	"./Nicholas Venn Springfield College.jpg": 1074,
	"./Pratik-giri.jpg": 1075,
	"./Praveen raval.57a24d7.jpg": 1076,
	"./Praveen raval.jpg": 1077,
	"./Rylan James.jpg": 1078,
	"./Shahina Khaitri.jpg": 1079,
	"./anjan.jpg": 1080,
	"./asif.png": 1081,
	"./avtar-1.png": 1082,
	"./fair-1.png": 1083,
	"./fair-2.png": 1084,
	"./fair-3.png": 1085,
	"./fair-4.png": 1086,
	"./fair-5.png": 1087,
	"./fair-6.png": 1088,
	"./img-1.png": 1089,
	"./mahonaraj.png": 1090,
	"./mehoonri.jpg": 1091,
	"./rylan.jpg": 1092,
	"./sandeep.jpg": 1093,
	"./seeneen mulla.jpg": 1094,
	"./shahnia.jpg": 1095,
	"./siddhi.jpg": 1096,
	"./sinjo.jpg": 1097,
	"./sonia.jpg": 1098
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial ^\.\/.*$
// module id = 337
// module chunks = 1